// extracted by mini-css-extract-plugin
export default {"prop":"style_prop__RiT0e"};